import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{class:_vm.cardClass,style:(_vm.styleCard),attrs:{"disabled":_vm.disabled,"color":_vm.colorCard,"max-width":_vm.widthCard,"elevation":_vm.elevation,"outlined":_vm.outlined}},[_c(VCardText,{staticClass:"p-2",style:(_vm.cardTextStyle)},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }